import { Component } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  standalone: false,
  selector: 'cva-lic-logoff-screen',
  templateUrl: './lic-logoff-screen.component.html'
})
export class LicLogoffScreenComponent {
  cvaUI_url = environment.cvaUI_url;
}
